module.exports = __webpack_public_path__ + "media/packs/images/flags/AE-4e4f4b59e746ba59023304867af5a18b.png";